module.exports = __webpack_public_path__ + "static/media/bcf01ba5-3d1a-4df6-8e45-f6ea08c3ef3b_1.599d38753979f06c09ca4f56213ef963.dae29994.jpeg";